<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 21C4.71667 21 4.479 20.904 4.287 20.712C4.09567 20.5207 4 20.2833 4 20C4 19.7167 4.09567 19.4793 4.287 19.288C4.479 19.096 4.71667 19 5 19H19C19.2833 19 19.5207 19.096 19.712 19.288C19.904 19.4793 20 19.7167 20 20C20 20.2833 19.904 20.5207 19.712 20.712C19.5207 20.904 19.2833 21 19 21H5ZM8 17C6.9 17 5.95833 16.6083 5.175 15.825C4.39167 15.0417 4 14.1 4 13V5C4 4.45 4.196 3.979 4.588 3.587C4.97933 3.19567 5.45 3 6 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V8C22 8.55 21.8043 9.02067 21.413 9.412C21.021 9.804 20.55 10 20 10H18V13C18 14.1 17.6083 15.0417 16.825 15.825C16.0417 16.6083 15.1 17 14 17H8ZM8 15H14C14.55 15 15.021 14.804 15.413 14.412C15.8043 14.0207 16 13.55 16 13V5H6V13C6 13.55 6.196 14.0207 6.588 14.412C6.97933 14.804 7.45 15 8 15ZM18 8H20V5H18V8Z"
      fill="#F18E35"
    />
  </svg>
</template>

<script>
export default {
  name: "PaymentCateringIcon",
};
</script>

<style scoped></style>
